<template>
  <ims-page :requireLogin="true">
    <!-- Page Header -->
    <template v-slot:header>
      <ims-toolbar>
        <template v-slot:left>
          <ims-back-button />
        </template>
        <div class="title">
          <div class="text-sm text-fade">Administration</div>
          <div
            class="text-md"
            v-if="league"
          >{{ league.leagueName }}</div>
        </div>
      </ims-toolbar>
      <!-- Tab Bar -->
    </template>
    <main
      class="league-admin container p-0"
      v-if="league"
    >
      <div class="desktop-bumper" />
      <members
        :id="$route.params.id"
        :refresh="refreshMembers"
      />

      <!-- Invite Player -->
      <section class="league-invite">
        <ims-item class="divider">Invite a New Player <span class="text-xs mb-2">Use commas to invite multiple people at the same time</span></ims-item>
        <ims-item class="pad ims-item-last">
          <ims-input
            inputClass="mb-0"
            type="text"
            placeholder="Email Address"
            required
            v-model="email"
          >
            <template v-slot:right>
              <ims-button
                :disabled="!isEmail"
                size="md"
                type="solid"
                color="primary"
                @click="invite()"
              >Invite</ims-button>
            </template>
          </ims-input>
        </ims-item>
      </section>

      <!-- League Name -->
      <section class="league-name">
        <ims-item class="divider">Change League Name</ims-item>
        <ims-item class="pad ims-item-last">
          <ims-input
            inputClass="mb-0"
            type="text"
            placeholder="League Name"
            ref="league_name"
            required
            v-model="name"
          >
            <template v-slot:right>
              <ims-button
                :disabled="!isValidName"
                size="md"
                type="solid"
                color="primary"
                @click="updateName"
              >Save</ims-button>
            </template>
          </ims-input>
        </ims-item>
      </section>

      <!-- Password -->
      <!-- <section class="league-password">
        <ims-item class="divider">Change League Password</ims-item>
        <ims-item class="pad">
          <ims-input
            inputClass="mb-0"
            type="password"
            placeholder="Password"
            required
            v-model="password"
          >
            <template v-slot:right>
              <ims-button size="md" type="solid" color="primary">Save</ims-button>
            </template>
          </ims-input>
        </ims-item>
      </section>-->

      <!-- Danger Area -->
      <!-- <section class="league-password">
        <ims-item class="divider">Danger Zone</ims-item>
        <ims-item class="p-1">
          <ims-button type="clear" color="red" @click="deleteLeague">Delete League</ims-button>
        </ims-item>
        <ims-item class="divider" />
      </section>-->
    </main>
  </ims-page>
</template>

<script>
import Members from '../containers/league-admin/members.vue';

export default {
  components: {
    Members
  },
  data() {
    return {
      name: '',
      email: '',
      password: '',
      league: null,
      refreshMembers: false
    };
  },
  mounted() {},
  watch: {
    league: function() {
      this.name = this.league.leagueName;
    },
    '$store.state.user.loggedIn': {
      async handler(isLoggedIn) {
        if (isLoggedIn) {
          this.init();
        }
      },
      immediate: true
    }
  },
  computed: {
    members(){
      return this.$store.state.leagues.members || {};
    },
    isEmail() {
      let emails = this.email ? this.email.split(',') : [];
      let enabled = (emails.length > 0) ? true : false;

      emails.forEach(email => {
        email = email.replace(/\s/g, '');
        if(enabled){
          enabled = (/^\w+([.(-|+)]?\w+)*@\w+([.-]?\w+)*(\.\w{2,3})+$/).test(email);
        }
      });

      return enabled;
    },
    isValidName() {
      return (
        (this.name || '').length > 3 && (this.name || '') !== this.league.name
      );
    }
  },
  methods: {
    async init() {
      // If store is empty - go load it
      if (this.$store.state.leagues.mine.length === 0) {
        await this.$store.dispatch('leagues/mine/load');
      }
      // Get league from store
      this.league = this.$store.getters.getLeague(this.$route.params.id);
    },
    async invite() {
      let emails = this.email ? this.email.split(',') : [];
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Sending Invite...'
      );

      for(let i = 0; i < emails.length; i++){
        emails[i] = emails[i].replace(/\s/g, '');
        let isCurrentMember = this.members.some(member => {
          return member.emailAddress == emails[i];
        });

        if(!isCurrentMember){
          try{
            let response = await this.$User.service.inviteToLeague(
              emails[i],
              this.$route.params.id
            );

            this.$store.dispatch('interact/toast', {
              title: `Invite sent to ${emails[i]}`
            });
            
          }catch(e){
            this.$store.dispatch('interact/error', `Unfortunately, you cannot invite ${emails[i]} because this email address is already playing Fantasy Racing in another game mode or platform.`);
          }
        }else{
          //this.$store.dispatch('interact/toast/hide');
          this.$store.dispatch('interact/error', `${emails[i]} has already been invited`);
        }

        if(i == emails.length - 1){
          this.email = null;
        }
      }

      // workaround to refresh members list on invite
      this.refreshMembers = !this.refreshMembers;

      closeLoader();
    },
    async updateName() {
      let closeLoader = await this.$store.dispatch(
        'loader/start',
        'Updating Name...'
      );
      let response = await this.$User.service.changeLeagueName(
        this.league.leagueId,
        this.name
      );
      if (response) {
        this.$store.dispatch('interact/toast', {
          title: `League Name Changed`
        });
      }

      this.$forceUpdate();
      closeLoader();
      // this.$store.dispatch('leagues/admin/edit', payload);
    },
    deleteLeague() {
      const self = this;
      this.$store.dispatch('interact/popmenu', {
        title: 'Are you sure you want to delete this league?',
        buttons: [
          {
            title: 'Delete League',
            click() {
              console.log('dispatch delete league');
              //self.$store.dispatch("leagues/private/delete", league);
            }
          }
        ]
      });
    }
  }
};
</script>
